import React              from 'react';

function DisplayStatusDCBox( { key, rec } ) {

    return(<> 
             { rec ? (<div className={'dcbox-state dcbox-score-'+ rec.ch + '-' + Math.round(rec.sc * 10.0) +' dcbox-state-' + rec.mz + '-' + rec.ch }>&nbsp;</div> ) : (<>Loading...</>) }
           </>);
}

export default DisplayStatusDCBox;
